/**
 * fileshare.service.ts — Layer 3: Org-level File Share Domain
 *
 * Backs the top-nav "Files" page (`/folder`, `/fileshare` routes). Distinct from
 * drive.service.ts, which backs the client-scoped file explorer (`/drive/*` routes).
 */

import { getRequest, postRequest, deleteRequest, postFormData } from './http.service';
import {
  URL_FOLDER,
  URL_FOLDER_LIST,
  URL_FOLDER_BY_ID,
  URL_FILESHARE,
  URL_FILESHARE_LIST,
  URL_FILESHARE_BY_ID,
  URL_FILESHARE_URL,
} from './url.service';

export const fetchFolderList = (orgId: string) =>
  getRequest(URL_FOLDER_LIST(orgId));

export const createFileshareFolder = (payload: Record<string, unknown>) =>
  postRequest(URL_FOLDER, payload);

export const deleteFileshareFolder = (folderId: string) =>
  deleteRequest(URL_FOLDER_BY_ID(folderId));

export const fetchFileshareFilesList = () =>
  getRequest(URL_FILESHARE_LIST);

export const uploadFileshareFile = (formData: FormData) =>
  postFormData(URL_FILESHARE, formData);

export const deleteFileshareFile = (fileId: string) =>
  deleteRequest(URL_FILESHARE_BY_ID(fileId));

export const fetchFileshareFileUrl = (fileId: string) =>
  getRequest(URL_FILESHARE_URL(fileId));
